import apiClient from './apiClient';

const requestService = {
  getRequests: (location = null) =>
    apiClient.get('/api/v1/requests', {
      params: { ...(location && { location }) },
    }),

  getRequestById: (id) =>
    apiClient.get(`/api/v1/requests/${id}`),

  updateRequestStatus: (workOrderId, workOrderStatus, comment = null) =>
    apiClient.patch(`/api/v1/requests/${workOrderId}`, { workOrderStatus, comment }),

  getRequestPriorities: () => apiClient.get('/api/v1/assets/priorities'),
};

export default requestService;
